module.exports = __webpack_public_path__ + "static/incentive-bg-3c9d717c674b385c5f3f2b15ca749c95.png";